import React from "react";
import SideBar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import { Outlet } from "react-router-dom";

const Layout = (props) => {
  const currUserData = true;

  return (
    <>
      {currUserData ? (
        <div id="wrapper">
          <div
            className="left_sidear
        "
          >
            <SideBar />
          </div>

          <div id="content-wrapper" className="d-flex flex-column">
            <Header />

            <div className="dashboard_content">
              <Outlet />
            </div>
            {/* <div className="footer p-3">
            <Footer />
          </div> */}
          </div>
        </div>
      ) : (
        <>
          <Outlet />
        </>
      )}
    </>
  );
};

export default Layout;
